<template>
  <v-card v-if="model.id" class="elevation-2">
    <v-card-title class="text-h5">
      <h2 class="font-weight-bold text--primary">Log Re-Instalación</h2>
    </v-card-title>
    <v-card-subtitle>
      <label class="subtitle-1 font-weight-bold black--text"> {{model.departamento.nombre}} </label>
    </v-card-subtitle>
    <v-card-text>
        <v-row dense>
          <v-col cols="12">
            <DataTableMain :datatable="table" :on-success='successTableAction' :itemsAction='tableAction' />
          </v-col>
        </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
import { Permission } from '@/mixins/permissionMain'
export default {
  props: ['model'],
  mixins: [Permission],
  data: () => ({
    itemInsumos: {},
    table: {
      header: {
        options: [],
        titles: [
          { text: 'IP', value: 'ip', class: 'black--text' },
          { text: 'Version', value: 'version', class: 'black--text' },
          { text: 'Fecha', value: 'fecha', class: 'black--text' },
          { text: 'Comentario', value: 'comentario', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: []
      },
      footer: {
        paging: true
      }
    }
  }),
  components: {
    DataTableMain
    // InsumoPickingDialog
  },
  mounted () {
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    ...mapMutations([]),
    successTableAction (item) {
      item.item = this.model
      this.onSuccess(item)
    },
    tableAction (item) {
      this.onSuccess(item)
    }
  },
  computed: {
    ...mapGetters([])
  },
  watch: {
    model (val) {
      this.table.body.data = val.log
    }
  }
}
</script>

<style>

</style>
